import {
  earthOutline,
  ellipse,
  helpBuoyOutline,
  helpCircleOutline,
  square,
  triangle,
} from "ionicons/icons";
import { Capacitor } from "@capacitor/core";
import {
  IonApp,
  IonBadge,
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
} from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { Redirect, Route, Switch } from "react-router-dom";
import AppUrlListener from "../AppUrlListener";
import AuthGuard from "../components/organisms/AuthGuard";
import {
  ResonanceLayoutProvider,
  useResonanceLayout,
} from "../components/organisms/ResonanceContext/ResonanceLayoutContext";
import ResonanceLayout from "../components/organisms/ResonanceContext/ResonanceLayout";
import NoSlug from "../pages/Default/NoSlug";
import HomeContent from "../pages/Home/HomeContent";
import LoggedHome from "../pages/LoguedHome/LoguedHome";
import Calendar from "../pages/Calendar/Calendar";
import InvitationPage from "../pages/Invitation/InvitationPage";
import Profile from "../pages/Profile/Profile";
import SequenceComponent from "../pages/SequenceComponent/SequenceComponent";
import SequenceComponentsPage from "../pages/SequenceComponents/SequenceComponents";
import FinishedQuestionnaires from "../pages/FinishedQuestionnaires/FinishedQuestionnaires";
import DisplayIsland from "../pages/MentalPlusPages/DisplayIsland";
import DisplayVideo from "../pages/MentalPlusPages/DisplayVideo";
import DisplayVideos from "../pages/MentalPlusPages/DisplayVideos";
import DisplayHelps from "../pages/MentalPlusPages/DisplayHelps";
import DisplayEvolution from "../pages/MentalPlusPages/DisplayEvolution";
import { useAuth } from "../contexts/AuthContext";
import {
  homeOutline,
  personOutline,
  trendingUpOutline,
  videocamOutline,
} from "ionicons/icons";
import PrivateRoute from "./PrivateRoute";
import IslandSettings from "../pages/MentalPlusPages/IslandSettings";
import SequenceComponents from "../pages/SequenceComponents/SequenceComponents";
import { useResonanceData } from "../components/organisms/ResonanceContext/ResonanceDataContext";

const Tabs: React.FC = () => {
  const { disableNav } = useResonanceLayout();
  const { sequences } = useResonanceData();
  const undoneCount = (sequences ?? [])
    .filter((seq) => seq.status !== "DONE")
    .flatMap((seq) =>
      seq.components.filter((c) => c.questionnaire_id && !c.is_done)
    ).length;

  return (
    <IonTabs
      onIonTabsWillChange={(e) => {
        // broadcast to any listeners (e.g., DisplayVideo instances)
        window.dispatchEvent(
          new CustomEvent("app:tab-will-change", {
            detail: { tab: e.detail.tab },
          })
        );
      }}
    >
      <IonRouterOutlet>
        <Redirect
          exact
          path="/:study_slug/tabs"
          to="/:study_slug/tabs/:tab(home)"
        />
        <PrivateRoute
          exact
          path="/:study_slug/tabs/:tab(home)"
          component={LoggedHome}
        />
        <PrivateRoute
          exact
          path="/:study_slug/tabs/:tab(videos)"
          component={DisplayVideos}
        />
        <PrivateRoute
          exact
          path="/:study_slug/tabs/:tab(helps)"
          component={DisplayHelps}
        />
        <PrivateRoute
          exact
          path="/:study_slug/tabs/:tab(evolution)"
          component={DisplayEvolution}
        />
        <PrivateRoute
          exact
          path="/:study_slug/tabs/:tab(questionnaires)"
          component={SequenceComponents}
        />
        <Route exact path="/:study_slug/tabs">
          <Redirect to="/:study_slug/tabs/:tab(home)" />
        </Route>
        <PrivateRoute
          exact
          path="/:study_slug/tabs/:tab(home)/island/:title"
          component={DisplayIsland}
        />
        <PrivateRoute
          exact
          path="/:study_slug/tabs/:tab(home)/island/:title/:contentType(Explications|Solutions)"
          component={DisplayVideos}
        />
        <PrivateRoute
          exact
          path="/:study_slug/tabs/:tab(home)/island/:title/:contentType(Explications|Solutions)/:id/:type"
          component={DisplayVideo}
        />
        <PrivateRoute
          exact
          path="/:study_slug/tabs/:tab(videos)/:id/:type"
          component={DisplayVideo}
        />
        <PrivateRoute
          exact
          path="/:study_slug/tabs/:tab(home)/island/:title/sequences/:sequenceId/components/:componentId"
          component={SequenceComponent}
        />
        <PrivateRoute
          exact
          path="/:study_slug/tabs/:tab(home)/island/:sequenceId/finished"
          component={FinishedQuestionnaires}
        />
        <PrivateRoute
          exact
          path="/:study_slug/tabs/:tab(questionnaires)/sequences/:sequenceId/components/:componentId"
          component={SequenceComponent}
        />
        <PrivateRoute
          exact
          path="/:study_slug/tabs/:tab(home)/island/:title/evolution"
          component={DisplayEvolution}
        />
      </IonRouterOutlet>

      {/* TAB BAR */}
      {!disableNav && (
        <IonTabBar slot="bottom" className="floating-tab-bar" id="ion-tab-bar">
          <IonTabButton tab="home" href="/mentalplus/tabs/home">
            <IonIcon icon={earthOutline} />
            <IonLabel>Home</IonLabel>
          </IonTabButton>
          <IonTabButton tab="videos" href="/mentalplus/tabs/videos">
            <IonIcon icon={videocamOutline} />
            <IonLabel>Video</IonLabel>
          </IonTabButton>
          <IonTabButton tab="helps" href="/mentalplus/tabs/helps">
            <IonIcon icon={helpBuoyOutline} />
            <IonLabel>Help</IonLabel>
          </IonTabButton>
          {/* <IonTabButton tab="questionnaire" href="/mentalplus/tabs/helps">
        <IonIcon icon={helpCircleOutline} />
        <IonLabel>Questionnaire</IonLabel>
      </IonTabButton> */}
          <IonTabButton tab="evolution" href="/mentalplus/tabs/evolution">
            <IonIcon icon={trendingUpOutline} />
            <IonLabel>Evolution</IonLabel>
          </IonTabButton>
          {/* <IonTabButton
            tab="questionnaires"
            href="/mentalplus/tabs/questionnaires"
          >
            <IonIcon icon={helpCircleOutline} />
            <IonLabel>Questions</IonLabel>
            {undoneCount > 0 && (
              <IonBadge color="danger">{undoneCount}</IonBadge>
            )}
          </IonTabButton> */}
        </IonTabBar>
      )}
    </IonTabs>
  );
};

export default Tabs;

//  <IonRouterOutlet key={outletKey}>

//             {/* PRIVATE ROUTES */}

//             <Route
//               exact
//               path="/:study_slug/profile"
//               render={(props) => {
//                 return !isInitialized ? null : isAuthenticated ? (
//                   <Profile />
//                 ) : (
//                   <Redirect to="/mentalplus/welcome" />
//                 );
//               }}
//             />
//        
//             <Route
//               exact
//               path="/:study_slug/invite"
//               render={(props) => {
//                 return !isInitialized ? null : isAuthenticated ? (
//                   <InvitationPage />
//                 ) : (
//                   <Redirect to="/mentalplus/welcome" />
//                 );
//               }}
//             />
//             <Route
//               exact
//               path="/:study_slug/sequences/:sequenceId/finished"
//               render={(props) => {
//                 return !isInitialized ? null : isAuthenticated ? (
//                   <FinishedQuestionnaires onClick={function (): void {
//                   } }/>
//                 ) : (
//                   <Redirect to="/mentalplus/welcome" />
//                 );
//               }}
//             />

//             {/* Fallback */}
//
//         </IonRouterOutlet>
